import moment from "moment-timezone";

export const fromZonedToLocal = (date: string | Date, timezone: string) => {
    return moment(date).tz(timezone, true).toDate();
};

export const fromZonedToLocalFormatted = (
    date: string | Date,
    timezone: string,
    format = "YYYY-MM-DD"
) => {
    return moment(date).tz(timezone, true).format(format);
};

export const fromLocalToZoned = (date: string | Date, timezone: string) => {
    if (Intl.DateTimeFormat().resolvedOptions().timeZone === timezone) {
        return moment.tz(date, timezone).toDate();
    }
    return moment.tz(date, timezone).local(true).toDate();
};

export const fromLocalToUTCFormatted = (date: string | Date, format = "YYYY-MM-DD") => {
    return moment(date).tz("UTC", true).format(format);
};
